module.exports = __webpack_public_path__ + "static/img/m_name.767490c.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/zxrx/m_name.png
// module id = 1UIk
// module chunks = 7